import { FC, useEffect } from "react";
import { useAppSelector } from "../../../store/reduxHooks";
import {
  SELECT_REQUEST_BANK_ID,
  SELECT_REQUEST_BANK_APPLICATION_STATUS,
} from "../../../store/selectors/requestAppSelector";
import { BankBaseInfoStatus } from "./bankStatusBlocks/BankBaseInfoStatus";
import { BankCommissionDocumentsInfoStatus } from "./bankStatusBlocks/BankCommisionDocumentsInfoStatus";
import {
  APPLICATION_BANK_STATUS_DEFAULT,
  APPLICATION_BANK_STATUS_KKB,
  BANK_NAME,
} from "../../../utils/guards/ApplicationBankStatusGuard/types";
import { SigningStatus } from "./connectedBanksStatusBlocks/statusesWithBaseInfo/signingStatus/SigningStatus";
import { StatusBaseInfoWithSignDocInfo } from "./connectedBanksStatusBlocks/statusesWithBaseInfo/baseInfoWithSignDocInfo/StatusBaseInfoWithSignDocInfo";
import { StatusesWithCommissionHideSignInfo } from "./connectedBanksStatusBlocks/statusesWithCommission/WithoutSignDocInfo/StatusesWithCommissionHideSignInfo";
import { DefaultStatusesWithCommission } from "./connectedBanksStatusBlocks/statusesWithCommission/default/DefaultStatusesWithCommission";
import { ApplicationStatusBaseInfo } from "../../Ui/Application/ApplicationStatusBaseInfo/ApplicationStatusBaseInfo";
import classes from "./BankClient.module.css";

// информация о банке для клиентов
export const BankClient: FC = () => {
  const data = useAppSelector(SELECT_REQUEST_BANK_ID);
  const bankStatus = useAppSelector(SELECT_REQUEST_BANK_APPLICATION_STATUS);

  useEffect(() => {
    localStorage.removeItem("selectedApplicationBank");
  }, []);

  if (bankStatus.bank_name === BANK_NAME.DEFAULT) {
    if (
      bankStatus.type === APPLICATION_BANK_STATUS_DEFAULT.DIRECTED ||
      bankStatus.type === APPLICATION_BANK_STATUS_DEFAULT.REJECTED ||
      bankStatus.type === APPLICATION_BANK_STATUS_DEFAULT.REVISION
    ) {
      return (
        <div className={classes.container}>
          <BankBaseInfoStatus />
        </div>
      );
    }

    if (
      bankStatus.type === APPLICATION_BANK_STATUS_DEFAULT.OFFER ||
      bankStatus.type === APPLICATION_BANK_STATUS_DEFAULT.REQUIRED_SIGNATURE ||
      bankStatus.type === APPLICATION_BANK_STATUS_DEFAULT.ISSUED
    ) {
      return (
        <div className={classes.container}>
          <BankCommissionDocumentsInfoStatus />
        </div>
      );
    }

    return <></>;
  }

  const statusContentBlocksMap = () => {
    if (
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.PROCESSING ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.OFFER ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.REFUSAL
    ) {
      return (
        <div className={classes.container}>
          <ApplicationStatusBaseInfo
            appNumber={data.id}
            status={data.status.title}
          />
        </div>
      );
    }

    if (
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.SIGNING ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.RESIGNING
    ) {
      return (
        <div className={classes.container}>
          <SigningStatus />
        </div>
      );
    }

    if (
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.DIRECTED ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.REVISION
    ) {
      return (
        <div className={classes.container}>
          <StatusBaseInfoWithSignDocInfo />
        </div>
      );
    }

    if (
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.DEAL_COMPLETED ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.AWAITING_PAYMENT
    ) {
      return (
        <div className={classes.container}>
          <StatusesWithCommissionHideSignInfo />
        </div>
      );
    }

    if (
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.PAID ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.SIGNATURE_REQUIRED ||
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.PROCESSED_BY_BANK
    ) {
      return (
        <div className={classes.container}>
          <DefaultStatusesWithCommission />
        </div>
      );
    }

    if(
      bankStatus.type === APPLICATION_BANK_STATUS_KKB.DOCUMENT_SIGNED
    ){
      return (
        <div className={classes.container}>
          <BankCommissionDocumentsInfoStatus />
        </div>
      )

    }

    return <></>;
  };

  return statusContentBlocksMap();
};
